import { FloatingTooltip } from '../../../../Floating'
import Text from '../../../../Text'

import {
  getRequestBoardCardLocation,
  getRequestBoardCardLocationTooltip,
} from './RequestBoardCardLocation.utils'

import * as styles from './RequestBoardCardLocation.module.css'

function RequestBoardCardLocation({ building, flat }) {
  const location = getRequestBoardCardLocation({ building, flat })

  return location ? (
    <FloatingTooltip
      content={getRequestBoardCardLocationTooltip({ building, flat })}
    >
      <Text isSecondary className={styles.RequestBoardCardLocation}>
        {location}
      </Text>
    </FloatingTooltip>
  ) : null
}

export default RequestBoardCardLocation
